import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=3a278747&scoped=true&"
import script from "./BannerItem.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BannerItem.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BannerItem.vue?vue&type=style&index=0&id=3a278747&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a278747",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a278747')) {
      api.createRecord('3a278747', component.options)
    } else {
      api.reload('3a278747', component.options)
    }
    module.hot.accept("./BannerItem.vue?vue&type=template&id=3a278747&scoped=true&", function () {
      api.rerender('3a278747', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuBanners/components/BannerItem.vue"
export default component.exports